import type { Components } from "@mui/material";

export const MuiMenu: Components["MuiMenu"] = {
  styleOverrides: {
    paper: {
      zIndex: 1300,
    },
  },
};
